<style>
p {
    font-family: 'Hammersmith One', sans-serif;
    font-size: 1vw;
    font-weight: 100;
    margin-left: 4vw;
}

#footer_div {
    display: flex;
    flex-direction: column;
}
</style>

<footer>
<div id="footer_div">
    <p>made by pretty interesting teenagers for pretty interesting teenagers at <a href="https://hackclub.com">Hack Club</a></p>
</div>
</footer>